import { useEffect, useState } from "react";
import { ProbeData } from "../../models/ProbeData";
import {
	deleteProbe,
	upsertProbeData,
} from "../../repositories/ProductionRepository";
import { useCastersContext } from "../CastersContext";

const useSaveProbe = () => {
	const [error, setError] = useState<string | null>();
	const [sucess, setSucess] = useState<string | null>(null);
	const { state, actions } = useCastersContext();
	const saveProbe = async (data: ProbeData) => {
		if (!state.processData || !state.processData.ProcessId) return;

		actions.setIsLoadingBackground(true);
		const resp = await upsertProbeData({
			ProbeId: data.ProbeId,
			Timestamp: data.Timestamp,
			Temperature: data.Temperature,
			Oxygen: data.Oxygen,
			ProcessId: state.processData.ProcessId,
			IsProbeManual: data.IsProbeManual,
		});
		actions.setIsLoadingBackground(false);
		if (resp.ok) {
			setSucess("Probe was saved successfully");
		} else {
			setError(resp.message);
		}
	};

	const removeProbe = async (probeId: number) => {
		actions.setIsLoadingBackground(true);
		const resp = await deleteProbe(probeId);
		if (resp.ok) setSucess("Probe was deleted");
		else setError(resp.message);
		actions.setIsLoadingBackground(false);
	};
	useEffect(() => {
		if (sucess) {
			actions.setNotificationMessage(sucess);
			setSucess("");
		}
		if (error) {
			actions.setErrorMessage(error);
			setError(null);
		}
	}, [sucess, error]);
	return { saveProbe, removeProbe, error, sucess };
};
export { useSaveProbe };
